import { Box } from "@mui/material";
import React from "react";

// 1 = (active, green ), 2= (pending, yellow), 0 = (inactive, red)

const CommonStatus = ({
  status,
  fontSize = "16px",
  rejectedStatusText = "Un-verified",
  approvedStatusText = "Verified",
  pendingStatusText = "Pending",
  refundStatusText = "Return",
  initiatedStatusText = "Initiated",
  minWidth,
  maxWidth,
}) => {
  const makeStatusReadable = (passedStatus) => {
    if (passedStatus === 1) {
      return approvedStatusText;
    } else if (passedStatus === 0) {
      return rejectedStatusText;
    } else if (passedStatus === 2 || passedStatus === "PENDING") {
      return pendingStatusText;
    } else if (
      passedStatus === "SUCCESS" ||
      passedStatus === "OPEN" ||
      passedStatus === "ONLINE" ||
      passedStatus === "APPROVED"
    ) {
      return approvedStatusText;
    } else if (
      passedStatus === "REJECTED" ||
      passedStatus === "FAILED" ||
      passedStatus === "CLOSED" ||
      passedStatus === "OFFLINE"
    ) {
      return rejectedStatusText;
    } else if (passedStatus === "REFUND") {
      return refundStatusText;
    } else if (passedStatus === "INITIATED") {
      return initiatedStatusText;
    } else {
      return passedStatus; // fallback for unknown
    }
  };

  const getBackgroundColor = () => {
    if (
      status === 1 ||
      status === "SUCCESS" ||
      status === "APPROVED" ||
      status === "OPEN"
    ) {
      return "linear-gradient(45deg, #1ee383, #16de4c)";
    } else if (status === 2 || status === "PENDING") {
      return "#808000";
    } else if (status === 0 || status === "REJECTED" || status === "FAILED") {
      return "linear-gradient(45deg, #ff5252, #ea4444)";
    } else if (status === "REFUND") {
      return "linear-gradient(45deg, #1260e0, #1751cf)";
    } else if (status === "INITIATED") {
      return "linear-gradient(45deg, #ff9800, #ff5722)";
    } else {
      return "linear-gradient(45deg, #9e9e9e, #7e7e7e)";
    }
  };

  const getBoxShadow = () => {
    if (
      status === 1 ||
      status === "SUCCESS" ||
      status === "APPROVED" ||
      status === "OPEN"
    ) {
      return "0px 4px 15px rgba(0, 255, 150, 0.2)";
    } else if (status === 2 || status === "PENDING") {
      return "0px 4px 15px rgba(255, 196, 0, 0.2)";
    } else if (status === 0 || status === "REJECTED" || status === "FAILED") {
      return "0px 4px 15px rgba(255, 0, 0, 0.2)";
    } else if (status === "REFUND") {
      return "0px 4px 15px rgba(0, 150, 255, 0.2)";
    } else if (status === "INITIATED") {
      return "0px 4px 15px rgba(255, 152, 0, 0.2)";
    } else {
      return "0px 4px 15px rgba(150, 150, 150, 0.2)";
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "8px 10px",
        minWidth: minWidth,
        maxWidth: maxWidth,
        fontSize: fontSize,
        color: "#ffffff",
        fontWeight: "700",
        borderRadius: "8px",
        textTransform: "uppercase",
        transition: "all 0.3s ease",
        justifyContent: "center",
        background: getBackgroundColor(),
        boxShadow: getBoxShadow(),
        "&:hover": {
          boxShadow: getBoxShadow().replace("4px", "6px").replace("15px", "20px"),
        },
      }}
    >
      <span>{makeStatusReadable(status)}</span>
    </Box>
  );
};

export default CommonStatus;
